<script>
  import {
    VMenu
  } from 'vuetify/lib'
  export default {
    name: 'wh-menu',
    extends: VMenu
  };
</script>